__webpack_require__.p = "https://staticfiles.nb-sandbox.com/bible-website-prod/_next/";